// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VIaqf,\n.VIaqf:hover {\n  color: var(--color-font);\n  font-size: var(--schoolinks-font-size-xs);\n}\n\n.LY2HY {\n  color: var(--color-white);\n}\n\n.gTrsj {\n  z-index: 1600;\n}\n\n.\\+a5C2 {\n  border-bottom: var(--border-default-gray-extra-light);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "VIaqf",
	"iconButton": "LY2HY",
	"menuRoot": "gTrsj",
	"userInfo": "+a5C2"
};
export default ___CSS_LOADER_EXPORT___;
